module.exports = __webpack_public_path__ + "img/work.e95d3da9.png";